export default {
  path: 'orders-invoices',
  name: 'vendor/orders-invoices',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "vendor-show-orders-invoices" */ './OrdersInvoices')
}
